import {
    ORIGINAL_LK_HREF_ATTR,
    appendUtmParamsToLkUrl,
    getUtmParamsFromStorage,
    hasUtmParams,
    isLkOilgasforumUrl,
} from './append-utm-to-lk-url';

function resolveOriginalHref(anchor: HTMLAnchorElement): string | null {
    const currentHref = anchor.getAttribute('href');
    if (!currentHref || !isLkOilgasforumUrl(currentHref)) {
        return null;
    }

    const storedOriginal = anchor.getAttribute(ORIGINAL_LK_HREF_ATTR);

    if (!storedOriginal) {
        anchor.setAttribute(ORIGINAL_LK_HREF_ATTR, currentHref);
        return currentHref;
    }

    if (!hasUtmParams(currentHref) && currentHref !== storedOriginal) {
        anchor.setAttribute(ORIGINAL_LK_HREF_ATTR, currentHref);
        return currentHref;
    }

    return storedOriginal;
}

export function applyUtmParamsToLkAnchor(anchor: HTMLAnchorElement, utmParams?: Record<string, string>): void {
    const params = utmParams ?? getUtmParamsFromStorage();
    if (Object.keys(params).length === 0) {
        return;
    }

    const originalHref = resolveOriginalHref(anchor);
    if (!originalHref || hasUtmParams(originalHref)) {
        return;
    }

    anchor.href = appendUtmParamsToLkUrl(originalHref, params);
}

export function applyUtmParamsToLkLinks(root: ParentNode = document): void {
    const utmParams = getUtmParamsFromStorage();
    if (Object.keys(utmParams).length === 0) {
        return;
    }

    root.querySelectorAll('a[href]').forEach((element) => {
        applyUtmParamsToLkAnchor(element as HTMLAnchorElement, utmParams);
    });
}
